<template>
  <div class="map-navigator" :style="setStyles" @click="mapNavigator">
    {{ option.attribute.label }}
  </div>
</template>

<script>
import {
  getDataJson,
  pollingRefresh,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data";
import { WeChat } from '@/views/viewsFunction/designerMethods'
export default {
  name: "cpt-map-navigator",
  props: {
    option: Object,
    height: Number,
    current: Object,
  },
  computed: {
    setStyles() {
      return {
        "--bgColor": this.option.attribute.bgColor,
        "--textColor": this.option.attribute.textColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,
        "--lineHeight": this.height + "px",
      };
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  data() {
    return {
      iptVal: "",
      newData: "",
      jsFunFlag: false,
      uuid:null,
    };
  },
  watch: {
    "option.attribute": {
      handler() {
        this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
      },
      deep: true,
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  created() {
    this.uuid = require("uuid").v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () =>
        this.loadData(cptDataForm, paras)
      );
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        that.jsFunFlag =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.jsFunction
            : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
      });
    },
    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      // 第一层判断 如果选择数据集
      console.log(cptDataForm.dataSource)
      if (cptDataForm.dataSource == "4") {
        if (
          this.current.cptOption.interaction.fatherGridId &&
          isFromGrid != "ninegrid"
        )
          return;
        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) {
          //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            let newres = [];
            let newObj = { ...res[0] };
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            newres.push(newObj);
            this.iptVal = newres[0].value;
          }
        } else {
          // 如果配置了转换脚本
          this.iptVal = res.value;
        }
      } else {
        // 不是数据集类型，是静态数据
        console.log(this.newData.value,' this.newData[0].value')
        this.iptVal = this.newData.value;
      }
    },
    //
    mapNavigator() {

       this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
       this.init(this.iptVal)
            //  console.log(this.iptVal, "经纬度");
      // console.log(this.isMobile(), "this.isMobile()");
      // if (this.isMobile()) {
        // if (this.iptVal != "") {
          // 判断iptVal是否为空
          // console.log(this.iptVal,'*')
          // window.Android.startNavi(this.iptVal); // 如果不为空，则调用并传入值
        // } else {
        //   console.log("导航目的地信息为空"); // 或者显示提示信息等
        // }
      // } else {
      //   console.log("当前不处于移动设备环境下");
      // }
    },
    init(val) {
      console.log(val,'val')
      let isMiniProgram = /MicroMessenger/i.test(navigator.userAgent);
      if(isMiniProgram) {
        WeChat.OpenLocation({
          scale: 18,
          latitude: val.split(',')[0],
          longitude: val.split(',')[1],
        })
        return;
      }
      let isAndroid = /android/i.test(navigator.userAgent);
      isAndroid ? window.Android.startNavi(val) : null;
      



       
    },
    isMobile() {
      // 使用正则表达式匹配常见的移动设备标识符
      const ua = navigator.userAgent;
      return /mobile|phone|android|iemobile/i.test(ua);
    },
  },
};
</script>

<style scoped>
.map-navigator {
  width: 100%;
  height: 100%;
  border: none;
  text-align: center;
  cursor: pointer;
  background-color: var(--bgColor);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
  line-height: var(--lineHeight);
}
</style>
